/**
 * Progress calculation utilities for masterclass cases.
 * Pure functions for calculating progress percentages.
 */

/**
 * Calculate the progress percentage for a single case.
 *
 * @param visitedSlideIds - Array of slide IDs that have been visited
 * @param totalSlides - Total number of slides in the case
 * @param completed - Whether the case has been marked as completed
 * @returns Progress percentage (0-100)
 */
export function calculateCaseProgress(
  visitedSlideIds: string[],
  totalSlides: number,
  completed: boolean
): number {
  // If completed, always return 100%
  if (completed) {
    return 100;
  }

  // Prevent division by zero
  if (totalSlides === 0) {
    return 0;
  }

  // Calculate percentage based on visited slides
  return Math.min((visitedSlideIds.length / totalSlides) * 100, 100);
}
